<template>
  <el-dialog
      center
      :title="$t('dashboard.fermetureServiceTitle')"
      :visible.sync="dialogVisible"
      :before-close="closeDialog"
      width="60%"
      v-if="shouldShowDialog">
    <div v-html="$t('dashboard.fermetureServiceMessage')"></div>
    <span slot="footer" class="dialog-footer">
        <el-button style="visibility: hidden;">{{ $t('dashboard.refuse') }}</el-button>
        <el-button type="primary" @click="closeDialog">{{ $t('dashboard.fermetureServiceButton') }}</el-button>
      </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DialogFermetureService',
  data () {
    return {
      dialogVisible: false,
      hasBeenShown: false
    }
  },
  computed: {
    ...mapGetters(['getUser']),
    shouldShowDialog () {
      const hasSeenMessage = sessionStorage.getItem('fermetureServiceViewed')
      return !hasSeenMessage && !this.hasBeenShown && this.getUser && this.getUser.id
    }
  },
  beforeMount () {
    if (this.shouldShowDialog) {
      this.dialogVisible = true
    }
  },
  methods: {
    closeDialog () {
      this.dialogVisible = false
      this.hasBeenShown = true
      sessionStorage.setItem('fermetureServiceViewed', 'true')
    }
  }
}
</script>

<style>
.dialog-footer {
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;
}
</style> 